import styles from './ErrorFallback.module.scss';

import { Button } from '@/components/Button';
import { useHapticFeedback } from '@/hooks/useHapticFeedback';

import { useTranslation } from 'react-i18next';

import SadChicken from './images/sad_chicken.png';

export const ErrorFallback = ({ error }: { error: string }) => {
  const { t } = useTranslation();
  const { triggerHapticFeedback } = useHapticFeedback();

  const handleReload = async () => {
    triggerHapticFeedback('medium');
    window.location.reload();
  };

  return (
    <div className={styles.errorWrapper}>
      <img className={styles.image} src={SadChicken} alt="Sad Chicken" />
      <h3 className={styles.title}>{t('Whoops')}</h3>
      <p className={styles.info}>{t('Try again')}</p>
      <p className={styles.errorMessage}>{error}</p>
      <div className={styles.button}>
        <Button onClick={handleReload}>{t('Reload')}</Button>
      </div>
    </div>
  );
};
